import React from 'react';

import MarkdownElement from 'utils/MarkdownElement';

import StarsIcon from './assets/stars.svg';
import useStyles from './styles';

interface Props {
    text: string;
    className?: string;
}

const GenerationResult: React.FC<Props> = ({ text, className }) => {
    const { classes, cx } = useStyles();

    return (
        <div className={cx(classes.root, className)}>
            <div className={classes.title}>
                <span className={classes.icon}>
                    <StarsIcon />
                </span>
                <p className={classes.text}>{'AI Insights'}</p>
            </div>
            <MarkdownElement className={classes.markdown} text={text} />
        </div>
    );
};

export default GenerationResult;
